<template>
  <div class="teenager-policy-page">
    <div class="policy-card">
      <h1 class="policy-title">未成年人保护协议</h1>

      <div class="policy-content">
        <section class="section">
          <h2 class="section-title">引言</h2>
          <p class="section-text">
            光星乐动（以下简称"我们"）高度重视未成年人的身心健康和合法权益保护。
            本协议旨在向未成年人及其监护人说明我们在未成年人保护方面的措施和责任，
            以及未成年人使用我们服务时应遵守的规则。请您在使用我们的服务前，
            仔细阅读并了解本协议内容。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">一、未成年人使用限制</h2>
          <p class="section-text">
            1. 年龄限制：
          </p>
          <ul class="list">
            <li>未满14周岁的儿童应在监护人的陪同下使用本服务；</li>
            <li>未满18周岁的未成年人应在监护人的指导下使用本服务；</li>
            <li>我们鼓励监护人为未成年人设置未成年人模式，以过滤不适宜内容。</li>
          </ul>
          <p class="section-text">
            2. 功能限制：
          </p>
          <ul class="list">
            <li>未成年人不得进行充值、打赏等消费行为；</li>
            <li>未成年人不得开启直播或发布涉及个人隐私的内容；</li>
            <li>未成年人不得与陌生人进行私信交流；</li>
            <li>未成年人每日使用时长将受到限制。</li>
          </ul>
        </section>

        <section class="section">
          <h2 class="section-title">二、未成年人模式说明</h2>
          <p class="section-text">
            我们为保护未成年人提供了未成年人模式，开启后将自动启用以下保护措施：
          </p>
          <ul class="list">
            <li>内容过滤：自动屏蔽不适宜未成年人观看的内容；</li>
            <li>时长限制：每日使用时长限制为40分钟，22:00-次日6:00无法使用；</li>
            <li>消费限制：禁止充值、打赏等一切消费行为；</li>
            <li>社交限制：限制私信功能，仅可与互相关注的好友交流；</li>
            <li>密码保护：关闭未成年人模式需要输入独立密码验证。</li>
          </ul>
        </section>

        <section class="section">
          <h2 class="section-title">三、监护人责任</h2>
          <p class="section-text">
            监护人在未成年人使用本服务时承担以下责任：
          </p>
          <ul class="list">
            <li>指导和监督未成年人正确使用网络服务；</li>
            <li>妥善保管账号密码，防止未成年人冒用成人身份；</li>
            <li>为未成年人开启未成年人模式并设置独立密码；</li>
            <li>关注未成年人的网络使用情况，及时发现和解决问题；</li>
            <li>教育未成年人保护个人隐私，不泄露个人信息。</li>
          </ul>
        </section>

        <section class="section">
          <h2 class="section-title">四、信息保护</h2>
          <p class="section-text">
            1. 信息收集原则：
          </p>
          <p class="section-text">
            我们遵循最小必要原则收集未成年人信息，未经监护人同意，
            我们不会收集未成年人的位置信息、通讯录等敏感信息。
          </p>
          <p class="section-text">
            2. 信息保护措施：
          </p>
          <ul class="list">
            <li>对未成年人信息进行加密存储和传输；</li>
            <li>严格限制内部人员访问未成年人信息的权限；</li>
            <li>不向第三方共享或披露未成年人个人信息；</li>
            <li>发现未成年人信息泄露时立即采取补救措施并通知监护人。</li>
          </ul>
        </section>

        <section class="section">
          <h2 class="section-title">五、内容管理</h2>
          <p class="section-text">
            1. 禁止内容：
          </p>
          <ul class="list">
            <li>含有暴力、恐怖、血腥等危害未成年人身心健康的内容；</li>
            <li>含有色情、低俗等不良信息；</li>
            <li>含有诱导未成年人不良行为或危险动作的内容；</li>
            <li>含有歧视、欺凌、侮辱他人等内容；</li>
            <li>其他不适宜未成年人接触的内容。</li>
          </ul>
          <p class="section-text">
            2. 内容审核：
          </p>
          <p class="section-text">
            我们建立了严格的内容审核机制，通过人工审核和技术手段，
            及时发现并处理违规内容，为未成年人营造健康的网络环境。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">六、投诉与举报</h2>
          <p class="section-text">
            如果您发现任何危害未成年人身心健康的内容或行为，可以通过以下方式进行举报：
          </p>
          <ul class="list">
            <li>在内容页面点击"举报"按钮进行举报；</li>
            <li>发送邮件至：gao_ming163@163.com；</li>
            <li>联系客服：86+18611573207。</li>
          </ul>
          <p class="section-text">
            我们将在收到举报后24小时内进行处理，并及时反馈处理结果。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">七、协议更新</h2>
          <p class="section-text">
            我们可能会根据法律法规的变化和业务发展的需要，适时更新本协议。
            更新后的协议将在平台上公布，重大变更我们会通过适当方式通知您。
            建议您定期查看本协议内容。
          </p>
        </section>

        <section class="section">
          <h2 class="section-title">八、联系我们</h2>
          <p class="section-text">
            如果您对本协议有任何疑问或建议，或需要行使您的权利，
            请通过以下方式联系我们：
          </p>
          <p class="section-text">
            公司名称：北京光星乐动科技有限公司
          </p>
          <p class="section-text">
            公司地址：北京市大兴区经济开发区科苑路9号3号楼三层T1389室
          </p>
          <p class="section-text">
            ICP备案号：京ICP备2025141949号-1
          </p>
        </section>
      </div>

      <div class="policy-footer">
        <p class="update-time">更新时间：2026年6月20日</p>
        <!-- <button class="btn-accept" @click="acceptPolicy">我已阅读并同意</button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeenagerPolicyPage',
  methods: {
    acceptPolicy() {
      this.$emit('accept')
      this.$message.success('已同意未成年人保护协议')
    }
  }
}
</script>

<style scoped lang="scss">
// B站直播风格令牌：粉 #fb7299 / hover #ff85ad / 浅粉 #fff0f5
// 文字 #18191c #61666d #9499a0 / 边框 #e3e5e7 / 分割 #f1f2f3 / 底 #f4f4f5

// 页面容器（由外层 .content 滚动，禁止 100vh 撑高）
.teenager-policy-page {
  min-height: 100%;
  background: #f4f4f5;
  padding: 24px 20px 32px;
  box-sizing: border-box;
}

// 协议白色卡片
.policy-card {
  max-width: 820px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #e3e5e7;
  border-radius: 8px;
  padding: 32px 36px;
  box-sizing: border-box;
}

// 主标题
.policy-title {
  font-size: 20px;
  font-weight: 600;
  color: #18191c;
  text-align: center;
  margin: 0 0 8px;
}

// 内容区域
.policy-content {
  margin-bottom: 24px;
}

// 章节
.section {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }

  .section-title {
    position: relative;
    font-size: 16px;
    font-weight: 600;
    color: #18191c;
    margin: 0 0 12px;
    padding-left: 10px;

    // 小粉条层级标记
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 14px;
      background: #fb7299;
      border-radius: 2px;
    }
  }

  .section-text {
    font-size: 14px;
    color: #61666d;
    line-height: 1.8;
    margin: 0 0 8px;
    text-align: justify;
  }

  // 保留默认序号样式，避免全局 reset 影响
  .list {
    list-style: disc;
    margin: 8px 0;
    padding-left: 24px;

    li {
      font-size: 14px;
      color: #61666d;
      line-height: 1.8;
      margin-bottom: 4px;
      padding-left: 2px;
    }
  }
}

// 底部区域
.policy-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #f1f2f3;

  .update-time {
    font-size: 12px;
    color: #9499a0;
    margin: 0;
  }

  .btn-accept {
    padding: 10px 40px;
    background: #fb7299;
    border: none;
    border-radius: 6px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background: #ff85ad;
    }
  }
}
</style>
